module.exports = __webpack_public_path__ + "static/fintechbuzz-a7eb0ba485943e9b3ba291c03a345fd9.png";